import type { FieldTypeFilterConfig, FieldTypeTemplate, PrimitiveType } from '#layers/data-model/public';
import type { FilterSchemaPrimitiveFieldMeta } from './filter-schema';
import { callOrReturn } from '#layers/base/public';
import { getPrimitiveFieldPresentationDefaults, getTypename } from '#layers/data-model/public';

/**
 * Minimal field shape consumed by resolveFilterConfig. Both FilterSchemaPrimitiveField
 * and the structural types used by useLogicalFilter are assignable.
 */
export interface FilterConfigResolvableField {
	type: PrimitiveType;
	meta?: FilterSchemaPrimitiveFieldMeta;
}

export function resolveFilterConfig(
	field: FilterConfigResolvableField | undefined,
	fieldTypeTemplates: Record<string, FieldTypeTemplate>,
): FieldTypeFilterConfig | undefined {
	if (!field) return undefined;

	const primitiveFilterDefaults = getPrimitiveFieldPresentationDefaults(field.type).filter;
	const typeTemplateId = field.meta?.typeTemplateId ?? primitiveFilterDefaults?.typeTemplateId;

	if (!typeTemplateId) return undefined;

	const template = fieldTypeTemplates[typeTemplateId];

	if (!template || template.type !== 'primitive' || !('filter' in template) || !template.filter) {
		return undefined;
	}

	return callOrReturn(template.filter, {
		options: field.meta?.typeOptions ?? undefined,
		primitiveType: getTypename(field.type),
	});
}
